import React from 'react';
import { X, ExternalLink } from 'lucide-react';

interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  productTitle?: string;
  productUrl?: string;
  siteName?: string;
}

const ImageModal: React.FC<ImageModalProps> = ({ 
  isOpen, 
  onClose, 
  imageUrl, 
  productTitle = 'Imagen del producto',
  productUrl,
  siteName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-75">
      {/* Fondo clickeable para cerrar */}
      <div 
        className="absolute inset-0" 
        onClick={onClose}
      />
      
      {/* Contenido del modal */}
      <div className="relative max-w-4xl max-h-[90vh] m-4">
        {/* Botón cerrar */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-2 transition-all"
        >
          <X className="h-6 w-6" />
        </button>
        {productUrl && (
          <a
            href={productUrl}
            target="_blank"
            rel="noreferrer"
            className="absolute top-4 left-4 z-10 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-2 transition-all"
            title={`Ver en ${siteName || 'sitio'}`}
          >
            <ExternalLink className="h-5 w-5" />
          </a>
        )}
        
        {/* Imagen */}
        <img
          src={imageUrl}
          alt={productTitle}
          className="max-w-[90vw] max-h-[75vh] min-w-[320px] min-h-[320px] object-contain rounded-lg shadow-2xl bg-white"
          onError={(e) => {
            (e.target as HTMLImageElement).src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0zMiAyOEMyOS43OTA5IDI4IDI4IDI5Ljc5MDkgMjggMzJDMjggMzQuMjA5MSAyOS43OTA5IDM2IDMyIDM2QzM0LjIwOTEgMzYgMzYgMzQuMjA5MSAzNiAzMkMzNiAyOS43OTA5IDM0LjIwOTEgMjggMzIgMjhaIiBmaWxsPSIjOUNBM0FGIi8+CjxwYXRoIGQ9Ik0yNCA0MEw0MCA0MEw0MCAyNEwyNCAyNEwyNCA0MFoiIHN0cm9rZT0iIzlDQTNBRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';
          }}
        />
        {/* Título del producto debajo de la imagen */}
        {productTitle && (
          <div className="mt-3 text-center">
            <p className="text-sm font-semibold leading-snug text-white break-words">{productTitle}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageModal; 
